import type { SectionTheme } from "#lib/web-ui/primitives/index.js";

import type { PortfolioAsset } from "@fergmar/contracts/public/portfolio";

export const assetTypeColors: Record<string, { hex: string; label: string }> = {
	"Multi-Family": { hex: "#2563eb", label: "Multi-Family" },
	Commercial: { hex: "#7c3aed", label: "Commercial" }
};

export const capitalStructureColors: Record<string, { hex: string; label: string }> = {
	"Corporate-Owned": { hex: "#166534", label: "Corporate-Owned" },
	Syndication: { hex: "#b45309", label: "Syndication" }
};

export interface PortfolioMapProps {
	assets: PortfolioAsset[];
	class?: string;
	center?: [number, number];
	zoom?: number;
	bounds?: [number, number, number, number];
	showLegend?: boolean;
}

export interface PortfolioAssetCardsProps {
	assets: PortfolioAsset[];
	label?: string;
	title?: string;
	subtitle?: string;
	theme?: SectionTheme;
	class?: string;
}
